import { createContext, useReducer } from "react";

import axios from "../utils/axios";
import WhatsappToUserReducer from "../reducers/WhatsappToUserReducer";
import { WhatsappToUserConstants } from "../constants/whatsapptouser.constants";
import { saveFile } from "../utils/common";

const initialState = {
  whatsappToUsers: [],
  paging: {
    totalNumberOfRecords: 0,
    totalNumberOfPages: 0,
    pageNumber: 0,
    pageSize: 0,
  },
  hasError: false,
  errorMessage: "",
  isSubmitting: false,
  isLoading: true,
  isLoadingDownload: false,
  downloadFileType: "",
};

const WhatsappToUserContext = createContext({
  ...initialState,
  getAllWhatsappToUser: () => {},
  addWhatsappToUser: () => {},
  downloadFile: () => {},
});

function WhatsappToUserProvider({ children }) {
  const [state, dispatch] = useReducer(WhatsappToUserReducer, initialState);

  const getAllWhatsappToUser = async (payload) => {
    try {
      dispatch({
        type: WhatsappToUserConstants.FETCH_WHATSAPPTOUSER_REQUEST,
      });
      const response = await axios.post("/radius/raduser/list", payload);
      dispatch({
        type: WhatsappToUserConstants.FETCH_WHATSAPPTOUSER_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: WhatsappToUserConstants.FETCH_WHATSAPPTOUSER_FAILURE,
      });
    }
  };

  const addWhatsappToUser = async (payload) => {
    try {
      dispatch({
        type: WhatsappToUserConstants.ADD_WHATSAPPTOUSER_REQUEST,
      });
      const response = await axios.post("/radius/raduser/send-whatsapp", payload);
      dispatch({
        type: WhatsappToUserConstants.ADD_WHATSAPPTOUSER_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: WhatsappToUserConstants.ADD_WHATSAPPTOUSER_FAILURE,
      });
      throw exception;
    }
  };

  const downloadFile = async (fileType, payload) => {
    dispatch({
      type: WhatsappToUserConstants.DOWNLOAD_WHATSAPPTOUSER_REQUEST,
      payload: { fileType },
    });
    const response = await axios.post("/radius/raduser/export/" + fileType, payload, {
      responseType: "blob",
    });
    await saveFile(response.data, "users." + fileType);
    dispatch({
      type: WhatsappToUserConstants.DOWNLOAD_WHATSAPPTOUSER_SUCCESS,
      payload: response.data,
    });
  };

  const getWhatsappTemplates = async () => {
    try {
      const response = await axios.get("/master/whatsapp-template/list");
      if (Array.isArray(response.data)) {
        return response.data;
      }
    } catch (e) {
      console.log("Error fetching WhatsApp templates:", e);
    }
    return [];
  };

  return (
    <WhatsappToUserContext.Provider
      value={{
        ...state,
        getAllWhatsappToUser,
        addWhatsappToUser,
        downloadFile,
        getWhatsappTemplates,
      }}
    >
      {children}
    </WhatsappToUserContext.Provider>
  );
}

export { WhatsappToUserContext, WhatsappToUserProvider };
